import { normalizeSubCategory } from "./normalizeSubCategory";

/**
 * Build URL paths for catalog entities using the new static category/sub-category structure.
 */
export function getCategoryPath(category) {
  return `/${category}/`;
}

export function getSubCategoryPath(productOrCategory, maybeSubCategory) {
  if (typeof productOrCategory === "string") {
    const category = productOrCategory;
    const sub = normalizeSubCategory(maybeSubCategory);
    return sub ? `/${category}/${sub}/` : `/${category}/`;
  }

  const category = productOrCategory.category;
  const sub = normalizeSubCategory(productOrCategory["sub-category"]);
  return sub ? `/${category}/${sub}/` : `/${category}/`;
}

export function getProductPath(product, slugOverride) {
  const slug = slugOverride || product.slug;
  return `/${slug}/`;
}

export function getProductDeepPath(product, slugOverride) {
  const category = product.category;
  const sub = normalizeSubCategory(product["sub-category"]);
  const slug = slugOverride || product.slug;

  return sub ? `/${category}/${sub}/${slug}/` : `/${category}/${slug}/`;
}
